import DOMPurify from 'dompurify';

export function getAnnouncementPlainText(html: string): string {
  const element = document.createElement('div');
  element.innerHTML = DOMPurify.sanitize(html);
  return element.textContent;
}
